import { ApiPeopleAnalyticsDateGrain } from "@/types/reporting/people-analytics.types.ts";
import { Button, DropdownMenu, DropdownMenuItem, FontAwesomeIcon } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface DateGrainSelectorProps {
  dateGrain: ApiPeopleAnalyticsDateGrain | null;
  onChange: (dateGrain: ApiPeopleAnalyticsDateGrain | null) => void;
}

// Показывается только когда группировка стоит на колонке-дате: иначе бэк отбивает грануляцию 422.
export function DateGrainSelector({ dateGrain, onChange }: DateGrainSelectorProps) {
  const { t } = useTranslation();

  const grainTitle = (value: ApiPeopleAnalyticsDateGrain) =>
    t(`reporting:people_analytics_date_grain_${value}`);

  return (
    <DropdownMenu
      trigger={
        <Button
          variant="secondary"
          leftIcon={<FontAwesomeIcon icon="fa-light fa-calendar-range" />}
        >
          {dateGrain ? grainTitle(dateGrain) : t("reporting:people_analytics_date_grain_none")}
        </Button>
      }
    >
      <DropdownMenuItem
        title={t("reporting:people_analytics_date_grain_none")}
        isSelected={!dateGrain}
        onClick={() => onChange(null)}
      />
      {Object.values(ApiPeopleAnalyticsDateGrain).map((value) => (
        <DropdownMenuItem
          key={value}
          title={grainTitle(value)}
          isSelected={value === dateGrain}
          onClick={() => onChange(value)}
        />
      ))}
    </DropdownMenu>
  );
}
